/**
 * 现状只读表格列：对齐 dataUpload 各模块 a-table 展示列（不含操作）
 * dataIndex 优先用 *_dictText，与填报页一致
 */
function col(title, dataIndex, width) {
  const item = { title, dataIndex, key: dataIndex, align: "center" };
  if (width) item.width = width;
  return item;
}

const SEQ = col("序号", "__seq", 70);

export const MODULE_TABLE_COLUMNS = {
  GZSTUANDUI: [
    SEQ,
    col("教师姓名", "teacherName", 100),
    col("性别", "sex", 70),
    col("学历", "education_dictText", 100),
    col("职称", "professionalTitle_dictText", 100),
    col("是否负责人", "izResponse", 110),
    col("加入年份", "joinYear", 100),
  ],
  GZSJIAOYANQINGKUANG: [
    SEQ,
    col("年份", "year", 150),
    col("次数", "num", 150),
  ],
  GZSZIJINYUSUAN: [
    SEQ,
    col("年份", "vintages", 150),
    col("资金来源", "capitalSource_dictText", 180),
    col("资金金额", "amount", 160),
  ],
  GZSZIJINZICHU: [
    SEQ,
    col("支出资金来源", "lxSubsudyFundId_dictText", 160),
    col("支出年份", "costYear", 120),
    col("支出项目", "project", 160),
    col("支出金额", "amount", 120),
  ],
  GZSKEYANQINGKUANG: [
    SEQ,
    col("类型", "type", 100),
    col("项目名称/文章名称", "xmmc"),
    col("立项单位/发表期刊", "lxdw"),
    col("立项时间/发表时间", "lxsj", 140),
    col("结项时间", "jxsj", 120),
    col("项目级别", "xnjb", 100),
    col("资助金额", "zzje", 100),
  ],
  GZSHUODONGFANGAN: [
    SEQ,
    col("年份", "year", 150),
    col("建设总结方案", "fileName"),
  ],
  GZSBIAOZHIXINGCHENGGUO: [
    SEQ,
    col("年份", "acquireYear", 120),
    col("成果名称", "title"),
    col("数量", "amount", 100),
    col("级别", "levelType", 100),
  ],
  GZSKCZSSZKC: [
    SEQ,
    col("年份", "activityYear", 120),
    col("类别", "szType", 140),
    col("数量", "num", 100),
  ],
  GZSTUANDUIJIANSHE: [
    SEQ,
    col("名称", "buildName"),
    col("年份", "acquireYear", 120),
    col("数量", "amount", 100),
  ],
  GZSSHIJIANJIDI: [
    SEQ,
    col("基地名称", "baseName"),
    col("基地类型", "baseType_dictText", 160),
    col("加入时间", "cooperativeTime", 140),
  ],
  GZSJIDIHUODONG: [
    SEQ,
    col("年份", "acquireYear", 120),
    col("主题", "subject"),
    col("人数", "peopleNum", 100),
    col("地点", "address"),
  ],
  GZSRONGYU: [
    SEQ,
    col("名称", "honorName"),
    col("年份", "acquireYear", 120),
    col("数量", "amount", 100),
  ],
  PEIYUPINPAI: [
    SEQ,
    col("名称", "brandName"),
    col("年度", "acquireYear", 120),
    col("级别", "levelType", 100),
  ],
  WKJIBENXINXI: [
    SEQ,
    col("名称", "name"),
    col("所属专业", "basicMajor_dictText", 140),
    col("申报年份", "applyYear", 100),
    col("团队成员", "groupNum", 100),
    col("思政微课视频", "hasResource", 120),
  ],

  // 品牌
  PPTUANDUI: [
    SEQ,
    col("教师姓名", "teacherName", 100),
    col("性别", "sex", 70),
    col("学历", "education_dictText", 100),
    col("职称", "professionalTitle_dictText", 100),
    col("是否负责人", "izResponse", 110),
    col("加入年份", "joinYear", 100),
  ],
  PPZHIJINYUSUAN: [
    SEQ,
    col("年份", "vintages", 150),
    col("资金来源", "capitalSource_dictText", 180),
    col("资金金额", "amount", 160),
  ],
  PPZHIJINSHIYONG: [
    SEQ,
    col("支出资金来源", "lxSubsudyFundId_dictText", 160),
    col("支出年份", "costYear", 120),
    col("支出项目", "project", 160),
    col("支出金额", "amount", 120),
  ],
  PPNIANDUJIAHUAN: [
    SEQ,
    col("年份", "year", 150),
    col("年度总结报告", "fileName"),
  ],
  PPHUODONG: [
    SEQ,
    col("活动名称", "name"),
    col("年份", "activityYear", 100),
    col("地点", "location"),
    col("参与人数", "partNum", 100),
  ],
  PPJIANSHE: [
    SEQ,
    col("年份", "constructionYear", 120),
    col("名称", "name"),
    col("类型", "type", 120),
    col("数量", "num", 100),
  ],
  PPSIZHENGYUREN: [
    SEQ,
    col("产品类型", "productType"),
    col("资源类别", "resourceCategory"),
    col("资源数量", "resourceNum", 100),
  ],
  PPCHENGGUO: [
    SEQ,
    col("成果名称", "achievementName"),
    col("数量", "achievementNum", 100),
    col("级别", "achievementLevel", 100),
  ],
  PPXUANCHUAN: [
    SEQ,
    col("年份", "addYear", 100),
    col("渠道载体", "channelCarrier"),
    col("发布数", "publicationNum", 100),
    col("点击数", "clickNum", 100),
  ],
  PPXIAOGUO: [
    SEQ,
    col("年份", "addYear", 100),
    col("类型", "type", 120),
    col("数量", "num", 100),
    col("奖项", "award"),
  ],

  // 微课
  WKTUANDUI: [
    SEQ,
    col("教师姓名", "teacherName", 100),
    col("性别", "sex", 70),
    col("学历", "education_dictText", 100),
    col("职称", "professionalTitle_dictText", 100),
    col("是否负责人", "izResponse", 110),
    col("加入年份", "joinYear", 100),
  ],
};

export function getModuleTableColumns(taskType) {
  return MODULE_TABLE_COLUMNS[taskType] || null;
}
